(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'CruiseBookingCabinCategories',
	};

	var _limitCategorySelection;
	var _handleMrIneligibleSelected;

	var mr_ineligible_msg = 'The cabin category you selected is not eligible for the Flex Membership Rewards promotion. If you wish to continue, your client will not receive any MR points for this booking. Press "Yes" to continue or "No" to cancel';

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		var $modal = $(".modal"),
			rate_code;

		// this needs to be moved to a centralized location at some point
		$('.rate-option-code').click(function showRateOptionDetails(e) {
			e.preventDefault();

			rate_code = $(this).data("code");

			$modal.find('.modal-title').text('Rate Option Details');
			$modal.find('.modal-body').html('<span class="'+Adzuki.FaIcon.getIconStyle('spinner')+' fa-2x fa-spin"></span> Retrieving rate option information...');
			$modal.modal('show');

			Adzuki.Ajax.get('/CruiseBooking/rateOptionRules/' + rate_code)
			.then(function populate(rules) {
				$modal.find('.modal-body').html(rules);
			});
		});

		$('.category-radio').change(function checkBoxIfExists(event) {
			var category_code = $(this).val(),
				category_parts;

			if (category_code.indexOf('|') > 0) {
				category_parts = category_code.split('|');
				category_code  = category_parts[1];
			}

			if ($('#upgrade-' + category_code)) {
				$('#upgrade-' + category_code).prop('checked', true);

				if (!$(this).is(':checked')) {
					$('#upgrade-' + category_code).prop('checked', false);
				}
			}

			_limitCategorySelection(this);
			_handleMrIneligibleSelected($(this));
		});

		$('.category-checkbox').click(function checkboxClicked(event) {
			var code          = $(this).attr('id');
			var category_code = code.replace('upgrade-', '');

			event.stopPropagation();

			if ($(this).prop('checked') === true) {
				$('.category-radio').each(function toggleRadio() {
					var current_category_code = $(this).val();
					var category_pieces       = [];

					if (current_category_code.indexOf('|') !== -1) {
						category_pieces = current_category_code.split('|');

						if (category_pieces.length > 1) {
							current_category_code = category_pieces[1];
						}
					}

					if (current_category_code === category_code) {
						$(this).prop('checked', true);
					}
				});
			}
		});

		$('.cabin-categories .clickable-row').click(function rowClicked(event) {
			var $row          = $(this);
			var category_code = $(this).data('code');

			if ($(event.target).hasClass('category-radio')) {
				return;
			}

			// $('.category-checkbox').each(function uncheckOtherBoxes() {
			// 	$(this).prop('checked', false);
			// });

			$('.category-radio').each(function setChecked() {
				var current_category_code = $(this).val();
				var category_pieces       = [];

				if (current_category_code.indexOf('|') !== -1) {
					category_pieces = current_category_code.split('|');

					if (category_pieces.length > 1) {
						current_category_code = category_pieces[1];
					}
				}

				if (current_category_code === category_code) {
					if ($(this).is(':checked')) {
						$(this).prop('checked', false);
						// uncheck the upgrade (if available)
						$row.find('.category-checkbox').prop('checked', false);
					} else {
						$(this).prop('checked', true);
						// check the upgrade (if available)
						$row.find('.category-checkbox').prop('checked', true);

						_limitCategorySelection(this);
						_handleMrIneligibleSelected($(this));
					}
				}
			});
		});

		$('.create-reservation').click(function click(e) {
			$('#cruisebookingcabincategories-action').val('create_reservation');

			$(form.element).submit();
		});

		$('.select-button').click(function click(e) {
			$('#cruisebookingcabincategories-category').val($(this).data('category'));

			$(form.element).submit();
		});

		_limitCategorySelection = function _limitCategorySelection(input)
		{
			var $input = $(input),
			    $row   = $input.closest('.table-row');

			if ($input.is('input[type="checkbox"]') && $('.category-radio:checked').length > 10) {
				$input.prop('checked', false);
				$input.parent().parent().find('.category-checkbox').prop('checked', false);

				// visually will get rid of selected checkbox/row when using .table-selectable
				$row.removeClass('selected');

				Adzuki.StatusMessage('error', 'You can only select up to 10 categories for live pricing', 'Max reached');
			}
		};

		_handleMrIneligibleSelected = function _handleMrIneligibleSelected(checkbox)
		{
			var mr_eligible     = checkbox.data('mr-eligible');
			var cat_mr_eligible = checkbox.data('cat-mr-eligible');

			if (
				mr_eligible !== undefined
				&& cat_mr_eligible !== undefined
				&& parseInt(mr_eligible) === 1
				&& parseInt(cat_mr_eligible) === 0
			) {
				form.confirm_message       = mr_ineligible_msg;
				form.confirm_before_submit = true;
			} else {
				form.confirm_message       = '';
				form.confirm_before_submit = false;
			}
		};
	};

}(jQuery, window.Adzuki || {}));
